import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';
import { GetProductsByVariantIdResponse } from '@jbhi-fi/apis/src/storefront/types';
import { getStoreCurrency } from '../utils/shopify/getStoreCurrency';
const storefrontClient = new ShopifyStorefrontClient();

type WishlistProduct = {
  id: string;
  name?: string;
  taxonomy?: Array<string>;
  currency: string;
  unit_price: number;
  unit_sale_price: number;
  url: string;
  product_image_url?: string;
  custom: {
    vendor: string;
    tags?: Array<string>;
    product_type?: string;
    handle: string;
    barcode?: string;
    taxable: boolean;
  };
  sku?: string;
};

export const onlineProductToWishlistProductTransformer = (
  product: GetProductsByVariantIdResponse['products'][0]
): WishlistProduct => {
  const { onlineProduct } = product.metafields;

  return {
    id: product.id.split('/').pop() ?? '',
    name: onlineProduct.Display.OnlineDescription,
    taxonomy: onlineProduct.Display.CategoryHierarchy,
    currency: getStoreCurrency(),
    unit_price: onlineProduct.Price.CoreTicketPrice,
    unit_sale_price: onlineProduct.Price.DisplayPriceInc,
    url: `https://${window.location.host}/products/${product.handle}`,
    product_image_url: onlineProduct.Display.Images[0]?.ImageUrl,
    sku: onlineProduct.Id,
    custom: {
      vendor: onlineProduct.Product.Brand,
      tags: onlineProduct.ProductTags?.AllCalculatedProductTags,
      product_type: onlineProduct.Department?.Description,
      handle: product.handle,
      barcode: onlineProduct.Product.Barcode,
      taxable: onlineProduct.Price.DisplayPriceTax > 0,
    },
  };
};

const getWishlist = async () => {
  const wishlistVariantIds = window.Jbhifi.customerWishlist.map(({ VariantId }) => VariantId);
  const products = await storefrontClient.getProductsByVariantId(wishlistVariantIds);
  return products.data?.products.map(onlineProductToWishlistProductTransformer);
};

export const initGetWishlist = () => {
  window.Jbhifi.getWishlist = getWishlist;
};
